import { render, staticRenderFns } from "./memberSearchDropdown.vue?vue&type=template&id=dfc411de&scoped=true&"
import script from "./memberSearchDropdown.vue?vue&type=script&lang=js&"
export * from "./memberSearchDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc411de",
  null
  
)

export default component.exports